import QRCodeView from 'qrcode.react';

export const QRCode = ({ value }) => {
  return <QRCodeView value={value} size={100} />;
};
